import { ILeadService } from 'types';

export const leadServices: ILeadService[] = [
    { isSelected: false, value: 'Delivery' },
    { isSelected: false, value: 'Catering' },
    { isSelected: true, value: 'Wine tastings' },
    { isSelected: false, value: 'Live music' },
    { isSelected: true, value: 'Outdoor seating' },
];
